// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bop-go/dati-commerciali/da-collegare?societaId=1&vista=costi-fornitore&anno=2026',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"vista":"costi-fornitore","data_riferimento":"DATA_REGISTRAZIONE","documenti_periodo":316,"importo_periodo":1424190.35,"importo_da_attribuire":83832.57,"data":[{"codice":3446,"etichetta":"CAPLAB SRL","codice_documento":"FATA","numero_documento":"2","importo":"100571.85","importo_con_commessa":"0.00","importo_senza_commessa":"100571.85"}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/dati-commerciali/totali?societaId=1&vista=costi-fornitore&raggruppa=fornitore&anno=2026&limit=20000',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"data":[{"codice":"string","etichetta":"string"}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/dati-commerciali/totali?societaId=1&vista=ricavi&raggruppa=cliente&anno=2026',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"vista":"ricavi","raggruppa":"cliente","data_riferimento":"DATA_DOCUMENTO","database":"arc_solu","count":3,"totale_complessivo":{"righe":4642,"documenti":1089,"importo":1984464.22,"importo_con_commessa":1360376.85,"importo_autofatture":0},"data":[{"codice":"00000011","etichetta":"ESSELUNGA SPA","righe":71,"documenti":56,"importo":824490.73}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/dati-commerciali/export/totali?societaId=1&vista=ricavi&raggruppa=cliente&anno=2026',
    requestBody: null,
    response: 'file xlsx'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/dati-commerciali/export/righe?societaId=1&vista=ricavi&raggruppa=cliente&anno=2026',
    requestBody: null,
    response: 'file xlsx'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
